import {useBreakpointValue} from '@salesforce/retail-react-app/app/components/shared/ui'
import _ from 'lodash'
import {useEffect, useMemo, useState} from 'react'
import {productInformationAttributes} from '../constants/pdp.constants'
import {useProduct} from '@salesforce/commerce-sdk-react'
import {useLocation} from 'react-router-dom/cjs/react-router-dom'

/* TODO: Try to merge getting internalProductId from location search params logic in useProductDetails hook */
export const useVariantProductDetails = () => {
    const location = useLocation()
    const [internalProductId, setInternalProductId] = useState(null)

    useEffect(() => {
        const searchParams = new URLSearchParams(location.search)
        const pid = searchParams.get('pid')
        setInternalProductId(pid)
    }, [location.search])

    const {
        data: product,
        isLoading: isProductLoading,
        isError: isProductError,
        error: productError
    } = useProduct(
        {
            parameters: {
                id: internalProductId,
                allImages: true
            }
        },
        {
            enabled: !!internalProductId
        }
    )

    const itemLength = useBreakpointValue({
        base: 50,
        sm: 60,
        md: 70,
        lg: 50,
        xl: 60
    })

    const getProductAttributes = (product) => {
        const productAttributes = {}
        product &&
            Object.keys(product).forEach((key) => {
                // Check if the key starts with 'c_' and has a numeric suffix

                if (key.startsWith('c_')) {
                    const attribute = key.slice(2) // Remove the 'c_' prefix
                    if (
                        !productAttributes[attribute] &&
                        productInformationAttributes[attribute]
                    ) {
                        productAttributes[attribute] = [product[key]]
                        return
                    }

                    if (productInformationAttributes[attribute]) {
                        productAttributes[attribute].push(product[key])
                        return
                    }

                    const attributeName = attribute.slice(0, -1) // Remove the numeric suffix

                    if (
                        !productAttributes[attributeName] &&
                        productInformationAttributes[attributeName]
                    ) {
                        productAttributes[attributeName] = [product[key]]
                        return
                    }

                    if (productInformationAttributes[attributeName]) {
                        productAttributes[attributeName].push(product[key])
                    }
                }
            })

        // Wrapping the result in the desired structure

        let tabIndex = 0
        const tabs = []
        const updateProductAttributes = _.reduce(
            _.keys(productInformationAttributes),
            (all, key) => {
                const attribute = productAttributes[key]
                if (!attribute?.length) {
                    return all
                }
                const attributeSettings = productInformationAttributes[key]

                const content = attributeSettings.join
                    ? _.join(attribute, ',&nbsp;')
                    : _.head(attribute)
                const isAccordion = content.length > itemLength

                if (isAccordion) {
                    const accordionIndex = tabIndex
                    tabIndex += 1

                    if (attributeSettings.visible) {
                        tabs.push(accordionIndex)
                    }

                    return {
                        ...all,
                        [key]: {
                            attributeContent: content,
                            isAccordion,
                            key,
                            accordionIndex
                        }
                    }
                }

                return {
                    ...all,
                    [key]: {
                        attributeContent: content,
                        isAccordion,
                        key
                    }
                }
            },
            {}
        )

        return {
            productAttributes: updateProductAttributes,
            productAttributeInitialOpenAccordions: tabs
        }
    }

    const updatedProduct = useMemo(() => {
        if (!product) {
            return product
        }
        return {...product, ...getProductAttributes(product)}
    }, [product])

    return {
        product: updatedProduct || product,
        isProductLoading: isProductLoading,
        isProductError: isProductError,
        productError: productError
    }
}
